import styled from "styled-components";
import { Menu as BaseMenu, Dropdown as BaseDropdown } from "antd";

import color from "../_style/color";
import percentToHex from "../utils/hexOpacity";

const MoreIcon = styled.span`
  display: block;
  margin: 2.5px 5px 2.5px 7.5px;
  width: 5px;
  height: 5px;
  border: 1px solid ${color.highgray};
  border-radius: 50px;
  float: none;
  cursor: pointer;
`;

const Menu = styled(BaseMenu)`
  padding: 0px !important;
  border-right: none;
  width: 256px;

  li {
    height: 30px;
    line-height: 30px;
    padding: 0 10px;
    font-size: 14px;
  }

  li:hover {
    background: ${color.whisper};
    color: ${color.primary};
    cursor: pointer;
  }

  .ant-dropdown-menu-item .ant-dropdown-menu-item-only-child {
    display: flex;
    align-items: center;
  }
`;

const MenuItem = styled(BaseMenu.Item)`
  .ant-menu:not(.ant-menu-horizontal) .ant-menu-item-selected {
    background-color: ${color.gainsboro + percentToHex(80)};
  }
`;

const Dropdown = styled(BaseDropdown)``;

Dropdown.Menu = Menu;
Dropdown.Menu.Item = MenuItem;
Dropdown.MoreIcon = MoreIcon;
const DropdownMenu =  {
  ...Menu,
  Item: MenuItem
}
export { MoreIcon, DropdownMenu };
export default Dropdown;
